// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./imgs/icon-star-medium-on.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./imgs/icon-star-medium-off.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./imgs/icon-star-medium-half.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./imgs/icon-star-on.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./imgs/icon-star-active.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./imgs/icon-star-half.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RatingStar-module__root--O3xbh {
  display: block;
  padding: 0;
  border: 0;
  background-color: transparent;
  background-position: center;
  background-repeat: no-repeat;
}

.RatingStar-module__size-medium--roi60 {
  width: 56px;
  height: 56px;
  flex: 0 0 56px;
  background-size: 56px 56px;
}

.RatingStar-module__size-medium--roi60.RatingStar-module__active--_ymmO {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.RatingStar-module__size-medium--roi60.RatingStar-module__inactive--shQMg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.RatingStar-module__size-medium--roi60.RatingStar-module__half--U8Ki9 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.RatingStar-module__size-small--qbI2x {
  width: 14px;
  height: 19px;
  flex-basis: 14px;
  background-size: 14px 13.5px;
}

.RatingStar-module__size-small--qbI2x.RatingStar-module__active--_ymmO {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.RatingStar-module__size-small--qbI2x.RatingStar-module__inactive--shQMg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.RatingStar-module__size-small--qbI2x.RatingStar-module__half--U8Ki9 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Rating/RatingStar.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,UAAU;EACV,SAAS;EACT,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,yDAAuD;AACzD;;AAEA;EACE,yDAAwD;AAC1D;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,yDAAgD;AAClD;;AAEA;EACE,yDAAoD;AACtD;;AAEA;EACE,yDAAkD;AACpD","sourcesContent":[".root {\n  display: block;\n  padding: 0;\n  border: 0;\n  background-color: transparent;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.size-medium {\n  width: 56px;\n  height: 56px;\n  flex: 0 0 56px;\n  background-size: 56px 56px;\n}\n\n.size-medium.active {\n  background-image: url('./imgs/icon-star-medium-on.svg');\n}\n\n.size-medium.inactive {\n  background-image: url('./imgs/icon-star-medium-off.svg');\n}\n\n.size-medium.half {\n  background-image: url('./imgs/icon-star-medium-half.svg');\n}\n\n.size-small {\n  width: 14px;\n  height: 19px;\n  flex-basis: 14px;\n  background-size: 14px 13.5px;\n}\n\n.size-small.active {\n  background-image: url('./imgs/icon-star-on.svg');\n}\n\n.size-small.inactive {\n  background-image: url('./imgs/icon-star-active.svg');\n}\n\n.size-small.half {\n  background-image: url('./imgs/icon-star-half.svg');\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `RatingStar-module__root--O3xbh`,
	"size-medium": `RatingStar-module__size-medium--roi60`,
	"active": `RatingStar-module__active--_ymmO`,
	"inactive": `RatingStar-module__inactive--shQMg`,
	"half": `RatingStar-module__half--U8Ki9`,
	"size-small": `RatingStar-module__size-small--qbI2x`
};
export default ___CSS_LOADER_EXPORT___;
